// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"c3141e1b","592":"1b2d514e","795":"86ad6890","875":"25f8ae36","985":"c033015f"}[chunkId] + ".chunk.js";
};